import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { UserHelperService } from "../../services/userHelper.service";
import { Observable } from "rxjs";
import { share } from "rxjs/operators";
import { LikeService } from "../../services/like.service";
import { ContentType, SnackBarMessageType } from "../../shared/contentTypes";
import { CoreLogService } from "../../services/log.service";
import { snackBarMessageKey, SnackBarService } from "../../services/snackBar.service";
import { ActivatedRoute } from "@angular/router";
import { LoginDialogComponent } from "../../modalDialogs/logindialog/logindialog.component";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";

@Component({
  selector: "ya-favoritebutton",
  templateUrl: "./favoritebutton.component.html",
  styleUrls: ["./favoritebutton.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoritebuttonComponent implements OnInit {

  @Output() onFavoriteClick = new EventEmitter<void>();
  @Input() likeStatus: boolean;
  @Input() modelId: number;
  @Input() contentType: ContentType;
  @Input() customClass: string;
  @Input() presentationMode: boolean = false;
  public isRegister: Observable<boolean>;
  constructor(private _userHelperService: UserHelperService
    , private _likeService: LikeService
    , private _coreLogService: CoreLogService
    , private _snackBarService: SnackBarService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _activatedRoute: ActivatedRoute
    , private _bottomSheetHelperService: BottomSheetHelperService) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error(`${this._activatedRoute.component["name"]} FavoritebuttonComponent.PushChanges`, "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    // share is used for performance. by useing share all the acync property in html use the same observable.
    me.isRegister = me._userHelperService.RegisterObserver.pipe(share());
  }

  /** click on like icon */
  public likeClick() {
    const me = this;
    me.onFavoriteClick.emit();
  }

  public favoriteClick() {
    const me = this;
    // change like, on error show error message
    me._likeService.SetLike(!me.likeStatus, me.contentType, me.modelId)
      .then(() => { /* all is okay, ignore */ })
      .catch(e => {
        me._coreLogService.error(`${me._activatedRoute.component["name"]} FavoritebuttonComponent.onFavoriteChange`, "SetLike", e);
        me._snackBarService.ShowErrorMessageFailed(109);
      });
    me.likeStatus = !me.likeStatus;
    me.PushChanges();
  }

  /**
   * If a user is not LoggedIn this modalDialog will be opened to redirect user to login page
   */
  public openLoginDialog(): void {
    const me = this;
    me._bottomSheetHelperService.open(LoginDialogComponent);
  }
}
